/**
 * 画面の公開パス。未設定のプロジェクトは空で、URL は従来の `/a/アプリ名` のまま。
 * 値は画面の index.html が Vite の base から入れる。`/` で始まらない値は無視する。
 */
export const frontPublicPathPrefix = (): string => {
  const value = (globalThis as { CORE_FRONT_PUBLIC_PREFIX?: unknown }).CORE_FRONT_PUBLIC_PREFIX
  if (typeof value !== 'string' || !value.startsWith('/') || value === '/') return ''
  return value.replace(/\/+$/, '')
}

/**
 * `/a/salespres` も `/core/a/salespres` も `salespres`。
 * `a` が無いときは空。従来の「3番目」だと `/core/a/...` のアプリ名が `a` になる。
 */
export const appKeyFromPathname = (pathname: string | undefined | null): string => {
  const parts = (pathname || '').split('/')
  const markerIndex = parts.indexOf('a')
  if (markerIndex < 0) return ''
  return parts[markerIndex + 1] || ''
}

export const appPublicPath = (appKey: string): string => {
  return `${frontPublicPathPrefix()}/a/${appKey}`
}
